import { render, staticRenderFns } from "./activity-session-game-table-input.vue?vue&type=template&id=0fad97c1&scoped=true&"
import script from "./activity-session-game-table-input.vue?vue&type=script&lang=ts&"
export * from "./activity-session-game-table-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad97c1",
  null
  
)

export default component.exports